import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=29453b06"
import script from "./Settings.js?vue&type=script&lang=js&external"
export * from "./Settings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports